"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventForm = void 0;
var axios_1 = require("axios");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var StyleComponents_1 = require("./base/StyleComponents");
var EventForm = function () {
    var _a = React.useState({}), name = _a[0], setName = _a[1];
    var _b = React.useState({}), email = _b[0], setEmail = _b[1];
    var _c = React.useState({}), type = _c[0], setType = _c[1];
    var _d = React.useState({}), number = _d[0], setNumber = _d[1];
    var _e = React.useState({}), date = _e[0], setDate = _e[1];
    var _f = React.useState({}), additional = _f[0], setAdditional = _f[1];
    var _g = React.useState({}), isValidEmail = _g[0], setIsValidEmail = _g[1];
    var _h = React.useState({}), isOkMessageOpen = _h[0], setIsOkMessageOpen = _h[1];
    React.useEffect(function () {
        setName('');
        setEmail('');
        setType(0);
        setNumber('');
        setDate('');
        setAdditional('');
        setIsOkMessageOpen(false);
        return function () {
            //kod zostanie wykonany przed kolejnym wywołaniem metody
        };
    }, []);
    var typeItems = [
        'Wybierz...',
        'Zwiedzanie / degustacja',
        'Impreza firmowa',
        'Wieczór panieński / kawalerski',
        'Wesele',
        'Inne'
    ];
    var valid = function () {
        var pattern = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
        var isEmailValid = email && pattern.test(email);
        setIsValidEmail(isEmailValid);
        return isEmailValid;
    };
    var sendMessage = function () {
        if (valid()) {
            axios_1.default.post('/api/email', {
                name: name,
                email: email,
                type: type === 0 ? '' : typeItems[type],
                number: number ? number : null,
                date: date ? date : null,
                additional: additional
            })
                .then(function (response) {
                setName('');
                setEmail('');
                setType(0);
                setNumber('');
                setDate('');
                setAdditional('');
                setIsOkMessageOpen(true);
            })
                .catch(function (error) {
                console.log(error);
            });
        }
    };
    return (React.createElement(reactstrap_1.Form, { style: {
            width: '80%'
        }, onSubmit: function (e) { e.preventDefault(); } },
        React.createElement(reactstrap_1.FormGroup, null,
            React.createElement(reactstrap_1.Label, { for: "name" }, "Imi\u0119 i nazwisko"),
            React.createElement(reactstrap_1.InputGroup, null,
                React.createElement(reactstrap_1.Input, { type: "text", name: "name", id: "name", placeholder: "", value: name, onChange: function (e) { return setName(e.target.value); } }))),
        React.createElement(reactstrap_1.FormGroup, null,
            React.createElement(reactstrap_1.Label, { for: "email" }, "Email"),
            React.createElement(reactstrap_1.InputGroup, null,
                React.createElement(reactstrap_1.Input, { type: "text", name: "email", id: "email", placeholder: "", value: email, onChange: function (e) { return setEmail(e.target.value); }, invalid: !isValidEmail }),
                React.createElement(reactstrap_1.FormFeedback, null, "Brak adresu email lub adres niepoprawny"))),
        React.createElement(reactstrap_1.FormGroup, null,
            React.createElement(reactstrap_1.Label, { for: "type" }, "Typ wydarzenia"),
            React.createElement(reactstrap_1.InputGroup, null,
                React.createElement(reactstrap_1.Input, { type: "select", name: "type", id: "type", value: type, onChange: function (e) { setType(e.target.value); } }, typeItems.map(function (item, key) { return React.createElement("option", { key: key, value: key }, item); })))),
        React.createElement(reactstrap_1.Row, null,
            React.createElement(reactstrap_1.Col, { sm: "7" },
                React.createElement(reactstrap_1.FormGroup, null,
                    React.createElement(reactstrap_1.Label, { for: "number" }, "Liczba os\u00F3b"),
                    React.createElement(reactstrap_1.Input, { type: "number", name: "number", id: "number", placeholder: "", min: 1, value: number, onChange: function (e) { return setNumber(e.target.value); } }))),
            React.createElement(reactstrap_1.Col, { sm: "5" },
                React.createElement(reactstrap_1.FormGroup, null,
                    React.createElement(reactstrap_1.Label, { for: "date" }, "Data wydarzenia"),
                    React.createElement(reactstrap_1.Input, { type: "date", name: "date", id: "date", value: date, onChange: function (e) { return setDate(e.target.value); } })))),
        React.createElement(reactstrap_1.FormGroup, null,
            React.createElement(reactstrap_1.Label, { for: "additional" }, "Dodatkowe informacje"),
            React.createElement(reactstrap_1.Input, { type: "textarea", name: "additional", id: "additional", value: additional, onChange: function (e) { return setAdditional(e.target.value); } })),
        React.createElement(reactstrap_1.Button, { style: {
                width: '100%',
                height: 50,
                fontSize: 20,
                marginTop: '1em'
            }, color: "success", onClick: function () { return sendMessage(); } }, "Wy\u015Blij"),
        isOkMessageOpen &&
            React.createElement(reactstrap_1.Modal, { centered: true, isOpen: isOkMessageOpen, toggle: function () { return setIsOkMessageOpen(false); } },
                React.createElement(reactstrap_1.ModalHeader, { style: { backgroundColor: StyleComponents_1.greenColor, color: 'white', textAlign: 'center' }, toggle: function () { return setIsOkMessageOpen(false); } }),
                React.createElement(reactstrap_1.ModalBody, { style: { backgroundColor: StyleComponents_1.greenColor, fontSize: 20, color: 'white', textAlign: 'center' } }, "Poprawnie wys\u0142ano wiadomo\u015B\u0107"),
                React.createElement(reactstrap_1.ModalFooter, { style: { backgroundColor: StyleComponents_1.greenColor, fontSize: 20, color: 'white', textAlign: 'center' } }))));
};
exports.EventForm = EventForm;
//# sourceMappingURL=EventForm.js.map